import * as yup from 'yup';

export const EditPropertySchemaGenerator = () =>
  yup.object({
    street_address: yup.string().required().nullable(),
    unit: yup.string().nullable(),
    city: yup.string().required().nullable(),
    zip_code: yup
      .string()
      .required()
      // eslint-disable-next-line
      .min(5, 'Enter ${min} digits')
      .nullable(),
  });

export const EditPropertySchema = EditPropertySchemaGenerator();
